import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrandsProvider } from "./context/BrandsContext";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrandsProvider>
        <App />
      </BrandsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
